<template>
    <div class="section-heading mb-3" style="background-color:#bbb;">{{schema.label}}</div>
</template>

<script>



export default {

    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        value: Object,
        schema: Object, 
    },

    computed: {

    },

    methods: {

    },

    created() {

    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// SectionHeadingControl.vue?310ae406